import { useFormik, FormikHelpers, FormikValues } from "formik";
import * as Yup from "yup";
import { BuildingFormFields } from "../../../../../api/graphql/workplaces";
import { RESOURCE_STRINGS as f } from "../../../../../lib/utils/constants";

const BuildingSchema = Yup.object().shape({
  name: Yup.string().min(2, f.validName).required(f.required),
});

interface UseBuildingFormOptions {
  enableReinitialize?: boolean;
  initialValues?: BuildingFormFields;
  onSubmit: (
    values: FormikValues,
    formikHelpers: FormikHelpers<BuildingFormFields>
  ) => Promise<any>;
}

export type BuildingFormik = ReturnType<typeof useBuildingFormik>;

export const useBuildingFormik = (opts: UseBuildingFormOptions) => {
  return useFormik<BuildingFormFields>({
    initialValues: {
      name: "",
      description: "",
      tags: [],
    },
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: BuildingSchema,
    ...opts,
    onSubmit: async (values, formikHelpers) => {
      await opts.onSubmit(values, formikHelpers);
    },
  });
};
